import React from 'react';

const StudentVisa = () => {
    return (
        <div class="hero mt-20 mb-16">
        <div class="hero-content flex-col lg:flex-row-reverse">
          <img src="https://i.ibb.co/34YVY56/Frame-27-1.png" class="admission" />
          <div>
            <div className="justify-center">
              <h1 class="text-start lg:ml-5 text-5xl font-medium text-primary text-3xl font-italic text-gold-600">
              Student
                <span className="text-secondary">
                  Visa
                </span>
              </h1>
  
              <p class="mt-8 text-lg text-justify lg:w-9/12 ">
              As border protection laws update frequently and vary with nationality, we implement our extensive experience to direct you toward a well-position for visa compliance. Once you get an admission offer from your dream university, you should consider assembling the documents for applying for a visa. In this regard, PFEC Global, being the best student visa agency in Bangladesh, can provide robust student visa services in Bangladesh with professional advice and conduct complete visa applications for those who struggle to find authentic information. Our visa processing services include:
              </p>
              <li className="mt-8 text-lg text-justify lg:w-9/12">
              Student visa for Australia
              </li>
              <li className="text-lg text-justify lg:w-9/12">
              Student visa for Canada
              </li>
              <li className="text-lg text-justify lg:w-9/12">
              Student visa for UK
              </li>
              <li className="text-lg text-justify lg:w-9/12">
              Student visa for USA
              </li>
            </div>
          </div>
        </div>
      </div>
    );
};

export default StudentVisa;